import { render, staticRenderFns } from "./Granos.vue?vue&type=template&id=de54de7e"
import script from "./Granos.vue?vue&type=script&lang=ts"
export * from "./Granos.vue?vue&type=script&lang=ts"
import style0 from "./Granos.vue?vue&type=style&index=0&id=de54de7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports